import { drawLine, getStyleFromRgb } from "tsparticles-engine";
export function drawGrabLine(context, width, begin, end, colorLine, opacity) {
  drawLine(context, begin, end);
  context.strokeStyle = getStyleFromRgb(colorLine, opacity);
  context.lineWidth = width;
  context.stroke();
}
export function drawGrab(container, particle, lineColor, opacity, mousePos) {
  container.canvas.draw(ctx => {
    var _particle$retina$link;
    const beginPos = particle.getPosition();
    drawGrabLine(ctx, (_particle$retina$link = particle.retina.linksWidth) !== null && _particle$retina$link !== void 0 ? _particle$retina$link : 0, beginPos, mousePos, lineColor, opacity);
  });
}